(() => {
  'use strict';
  function mount(root) {
    if (root.dataset.dtfBuyerMounted) return;
    const guide = root.querySelector('dialog.fp-reseller');
    const dialog = root.querySelector('[data-dtf-buyer-dialog]');
    const entry = root.querySelector('[data-dtf-buyer-entry]');
    const trigger = root.querySelector('[data-dtf-buyer-open]');
    const material = root.querySelector('[data-gpr-material]');
    if (!guide || !dialog || !entry || !trigger || !material || typeof dialog.showModal !== 'function') return;
    root.dataset.dtfBuyerMounted = 'true';
    function sync() {
      entry.hidden = !['dtf', 'glitter'].includes(material.value);
      if ((entry.hidden || !guide.open) && dialog.open) dialog.close();
    }
    trigger.addEventListener('click', () => {
      sync();
      if (entry.hidden || !guide.open || dialog.open) return;
      dialog.showModal();
      dialog.querySelector('.gpr-buyer-scroll').scrollTop = 0;
    });
    dialog.querySelectorAll('[data-dtf-buyer-close]').forEach(button => {
      button.addEventListener('click', () => dialog.close());
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('cancel', event => {
      event.stopPropagation();
    });
    dialog.addEventListener('close', () => {
      if (guide.open && !entry.hidden) trigger.focus({ preventScroll: true });
    });
    guide.addEventListener('close', sync);
    root.addEventListener('change', event => {
      if (event.target === material) sync();
    });
    new MutationObserver(sync).observe(guide, { attributes: true, attributeFilter: ['open'] });
    sync();
  }
  const boot = () => document.querySelectorAll('[data-gpr-root]').forEach(mount);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
